import { Route } from '@angular/router';

export const scoreTrainingStatisticsRoutes: Route[] = [
    {
        path: 'score-training/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/score-training-statistics-details/score-training-statistics-details.component').then(
                (c) => c.ScoreTrainingStatisticsDetailsComponent
            ),
    },
    {
        path: 'score-training/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/score-training-statistics-games/score-training-statistics-games.component').then(
                (c) => c.ScoreTrainingStatisticsGamesComponent
            ),
    },
    {
        path: 'score-training/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/score-training-statistics-games-details/score-training-statistics-games-details.component'
            ).then((c) => c.ScoreTrainingStatisticsGamesDetailsComponent),
    },
];
